<div class="fake-mode-cover" *ngIf="isDemo"></div>
<section class="db-add-ecommerce-menu-wrapper">
  <div class="db-add-ecommerce-menu-header" *ngIf="!isDemo">
    <div class="route-container">
      <span (click)="navigateBack()">{{ 'text_navigation' | dbText }}</span>
      <i class="db-icon db-icon-ds-arrow-right"></i>
      <span>{{menuId ? ('text_editMenu' | dbText) : ('text_addNewMenu' | dbText)}}</span>
    </div>
    <div class="actions-container">
      <button class="ds-btn"
              (click)="onDiscard()"
              [ngClass]="{'ds-btn-disabled': false}">
        {{'text_productsDiscardBtn' | dbText}}
      </button>
      <button class="ds-btn-black"
              (click)="onSave()"
              [class.ds-btn-disabled]="menuNameControl?.invalid">
        {{'text_saveTags' | dbText}}
      </button>
    </div>
  </div>
  <div class="db-add-ecommerce-menu-body" *ngIf="!loading; else loadingTemp">
    <div class="title-field-container">
      <div class="required-field-label">
        <span>{{ 'text_menuName' | dbText }}<span [class.invalid]="false"
                             class="required-mark">
            *
          </span>
        </span>
      </div>
      <input class="ds-input"
             [ngClass]="{error:menuNameControl.touched && menuNameControl.invalid}"
             [formControl]="menuNameControl"
             type="text"
             [placeholder]="'text_mainMenu' | dbText">
      <div class="field-invalid-message"
           *ngIf="menuNameControl.touched && menuNameControl.invalid">
        {{ 'text_menuNameIsRequired' | dbText }}
      </div>
    </div>
    <db-ecommerce-menu-structure [opened]="menuState === 'open'"
                                 [ngClass]="menuState"
                                 [isDemo]="isDemo" (openSlider)="toggleMenu()"></db-ecommerce-menu-structure>
  </div>
  <ng-template #loadingTemp>
    <db-loading-screen></db-loading-screen>
  </ng-template>
  <div class="menu-slider" [@menuSlider]="menuState">
    <db-ecommerce-menu-sidebar *ngIf="!isDemo" (closeSidebar)="closeSidebar()"></db-ecommerce-menu-sidebar>
  </div>
</section>
